import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { UserApiV2 } from './types/User';

type UserSettings = Partial<UserApiV2>;

const updateUser = (makeCall: MakeCall) => (
  userId: number | 'me',
  data: UserSettings,
) =>
  makeCall<UserApiV2>('PUT', `${APIV2_URL}/user/${userId}`, {
    data,
  });

export default updateUser;
